module.exports = __webpack_public_path__ + "static/media/chevron.cf1fb6ad.svg";